import { gql } from "graphql-request";

const SERVER_COMPLETE_SURVEY = gql`
  mutation SERVER_CompleteSurvey($userSurveyId: ID!) {
    completeSurvey(userSurveyId: $userSurveyId)
  }
`;
export default SERVER_COMPLETE_SURVEY;